<template>
  <!-- Whole Structure -->
  <div class="overflow-hidden max-w-full relative">
    <!-- Header Section Start here -->
    <header class="inset-x-0 absolute top-0 z-50">
      <div class="max-w-screen-2xl mx-auto px-4 md:px-8 3xl:px-0 w-full">
        <nav class="relative flex justify-between h-20 md:justify-center" aria-label="Global">
          <div class="flex items-center flex-1 md:absolute md:inset-y-0 md:left-0">
            <div class="flex items-center justify-between w-full md:w-auto">
              <a href="#hero">
                <img class="flex h-10 w-auto" src="/img/spike-logo.svg" alt="Spike Logo" />
              </a>
              <div class="-mr-2 flex items-center md:hidden">
                <button
                  type="button"
                  class="bg-gray-50 rounded-md p-2 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary focus:text-primary"
                  aria-expanded="false"
                  @click="menu = !menu"
                >
                  <span class="sr-only">Open main menu</span>
                  <!-- Heroicon name: outline/menu -->
                  <svg
                    class="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="hidden md:flex md:space-x-3 lg:space-x-5 xl:space-x-14 md:text-sm lg:text-lg">
            <a href="#overview" class="border-primary text-primary inline-flex items-center px-1 pt-1 border-b-2">
              Overview
            </a>
            <a
              href="#features"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              Features
            </a>
            <a
              href="#pricing"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              Pricing
            </a>
            <a
              href="#clients"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              Clients
            </a>
            <a
              href="#security"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              Security
            </a>
            <a
              href="#privacy"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              Privacy
            </a>
            <a
              href="#faq"
              class="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2"
            >
              FAQ
            </a>
          </div>
          <div class="hidden md:absolute md:flex md:items-center md:justify-end md:inset-y-0 md:right-0">
            <span class="inline-flex rounded-md shadow">
              <a
                :href="signInUrl"
                class="inline-flex items-center px-5 py-2 text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 transition ease-in-out duration-300"
              >
                Get started
              </a>
            </span>
          </div>
        </nav>
      </div>

      <div
        class="fixed top-0 inset-0 z-50 h-screen flex justify-end items-stretch"
        v-show="menu"
        x-transition:enter="transition ease-out duration-500"
        x-transition:enter-start="opacity-0 transform translate-x-full"
        x-transition:enter-end="opacity-100 transform translate-x-0"
        x-transition:leave="transition ease-in duration-500"
        x-transition:leave-start="opacity-100 transform translate-x-0"
        x-transition:leave-end="opacity-0 transform translate-x-full"
      >
        <div
          class="fixed inset-0 bg-opacity-90 bg-primary transition ease-in-out duration-500"
          @click="menu = !menu"
        ></div>
        <div class="shadow-new bg-white overflow-hidden flex flex-col w-80 relative z-10">
          <div class="px-5 pt-4 flex items-start justify-between">
            <div>
              <img class="w-20" src="/img/spike-logo.svg" alt="" />
            </div>
            <div class="-mr-2">
              <button
                type="button"
                class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none"
                @click="menu = !menu"
              >
                <span class="sr-only">Close menu</span>
                <!-- Heroicon name: outline/x -->
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
          <div class="p-4 overflow-y-auto max-h-full">
            <div class="">
              <div class="divide-y divide-gray-200 flex flex-col font-headings font-semibold border-t border-gray-200">
                <a href="#overview" class="text-primary inline-flex items-center py-3">Overview</a>
                <a href="#features" class="text-gray-500 hover:text-primary inline-flex items-center py-3">
                  Features
                </a>
                <a href="#pricing" class="text-gray-500 hover:text-primary inline-flex items-center py-3">Pricing</a>
                <a href="#clients" class="text-gray-500 hover:text-primary inline-flex items-center py-3">Clients</a>
                <a href="#security" class="text-gray-500 hover:text-primary inline-flex items-center py-3">
                  Security
                </a>
                <a href="#privacy" class="text-gray-500 hover:text-primary inline-flex items-center py-3">Privacy</a>
                <a href="#faq" class="text-gray-500 hover:text-primary inline-flex items-center py-3">FAQ</a>
              </div>

              <div class="flex border-t border-gray-200 pt-5">
                <span class="inline-flex rounded-md shadow">
                  <a
                    :href="signInUrl"
                    class="inline-flex items-center px-5 py-2 text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 transition ease-in-out duration-300"
                  >
                    Get started
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main>
      <!-- Hero -->
      <section id="hero">
        <div class="max-w-screen-2xl mx-auto px-4 2xl:px-0 pt-20 lg:pt-32 xl:py-40 flex justify-center items-center">
          <div class="w-full">
            <div
              x-data="{swiper: null}"
              x-init="swiper = new Swiper($refs.container, {
                loop: true,
                navigation:false,
                pagination: {
                  el: '.swiper-pagination',
                  bulletElement:'button',
                  clickable: true,
                  bulletClass:'bg-gray-300 inline-flex rounded-full w-5 h-5 cursor-pointer focus:outline-none hover:bg-blue-500',
                  bulletActiveClass:'bg-blue-500',
                  currentClass:'bg-primary',
                },
                observer: true,
                observeParents: true,
                slidesPerView: 1,
                spaceBetween: 0,

              })"
              class="relative flex flex-row pb-10"
            >
              <div class="swiper-container" x-ref="container">
                <div class="swiper-wrapper">
                  <!-- Slides -->
                  <div class="swiper-slide flex p-4">
                    <div class="flex flex-col lg:flex-wrap lg:grid lg:grid-cols-12 lg:gap-8">
                      <div class="sm:text-center lg:col-span-6 lg:text-left">
                        <h1>
                          <span
                            class="mt-1 block text-3xl tracking-tight font-normal sm:text-4xl xl:text-5xl xl:leading-snug"
                          >
                            <span class="block text-gray-900">
                              Extract transactions from bank statements ... instantly!
                            </span>
                          </span>
                        </h1>
                        <p class="mt-3 text-base text-gray-900 sm:mt-5 sm:text-xl lg:text-lg xl:text-2xl">
                          (no manual editing required)
                        </p>

                        <div class="lg:mt-10 mt-5 flex justify-center lg:justify-start">
                          <div class="rounded-md shadow">
                            <a
                              :href="signInUrl"
                              class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 md:py-4 md:text-lg md:px-10 transition duration-300 ease-in-out"
                            >
                              Get started
                            </a>
                          </div>
                        </div>

                        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                          Free trial, no credit card required.
                        </p>
                      </div>
                      <div
                        class="relative mt-10 lg:col-span-6 flex items-center lg:justify-start justify-center xl:min-h-[20rem] flex-col"
                      >
                        <img src="/img/slide-1.png" alt="" />
                        <p class="text-xl text-gray-900 mt-5 tracking-wider">Import into Excel, Xero, Sage/Pastel</p>
                      </div>
                    </div>
                  </div>

                  <!-- Slides -->
                  <div class="swiper-slide flex p-4">
                    <div class="flex flex-col lg:flex-wrap lg:grid lg:grid-cols-12 lg:gap-8">
                      <div class="sm:text-center lg:col-span-6 lg:text-left">
                        <h2>
                          <span
                            class="mt-1 block text-3xl tracking-tight font-normal sm:text-4xl xl:text-5xl xl:leading-snug"
                          >
                            <span class="block text-gray-900">Get setup in less than a minute</span>
                          </span>
                        </h2>
                        <p class="mt-3 text-base text-gray-900 sm:mt-5 sm:text-xl lg:text-lg xl:text-2xl">
                          Create a free account now and use our online converter to turn your bank .pdfs into Excel
                          .csvs
                        </p>

                        <div class="lg:mt-10 mt-5 flex justify-center lg:justify-start">
                          <div class="rounded-md shadow">
                            <a
                              :href="signInUrl"
                              class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 md:py-4 md:text-lg md:px-10 transition duration-300 ease-in-out"
                            >
                              Get started
                            </a>
                          </div>
                        </div>

                        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                          Free trial, no credit card required.
                        </p>
                      </div>
                      <div
                        class="relative lg:col-span-6 flex lg:justify-end justify-center flex-1 mt-10"
                        style="height: 360px; overflow: hidden"
                      >
                        <div class="bg-gray-200 w-full max-w-xl flex items-center justify-center xl:min-h-[20rem]">
                          <a href="https://asciinema.org/a/417070" rel="nofollow">
                            <img
                              src="https://camo.githubusercontent.com/7c3b412a3df1093f122b52fa2f1a9a10859c3e32e17c3fcb6ca221f79a89ef1c/68747470733a2f2f61736369696e656d612e6f72672f612f3431373037302e737667"
                              alt="asciicast"
                              data-canonical-src="https://asciinema.org/a/417070.svg"
                              style="max-width: 100%"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Slides -->
                  <div class="swiper-slide flex p-4">
                    <div class="flex flex-col lg:flex-wrap lg:grid lg:grid-cols-12 lg:gap-8">
                      <div class="sm:text-center lg:col-span-6 lg:text-left">
                        <h2>
                          <span
                            class="mt-1 block text-3xl tracking-tight font-normal sm:text-4xl xl:text-5xl xl:leading-snug"
                          >
                            <span class="block text-gray-900">Use our API</span>
                          </span>
                        </h2>
                        <p class="mt-3 text-base text-gray-900 sm:mt-5 sm:text-xl lg:text-lg xl:text-2xl">
                          Write your own software to access bank statements by using our API
                        </p>

                        <div class="lg:mt-10 mt-5 flex justify-center lg:justify-start">
                          <div class="rounded-md shadow">
                            <a
                              :href="signInUrl"
                              class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 md:py-4 md:text-lg md:px-10 transition duration-300 ease-in-out"
                            >
                              Get started
                            </a>
                          </div>
                        </div>

                        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                          Free trial, no credit card required.
                        </p>
                      </div>
                      <div class="relative lg:col-span-6 flex items-stretch lg:justify-end justify-center flex-1 mt-10">
                        <div class="w-full max-w-xl flex flex-col items-start">
                          <div class="w-full flex flex-1 items-center justify-center xl:min-h-[20rem]">
                            <img src="/img/hero/code.png" alt="codesnap" class="object-cover max-w-full" />
                          </div>
                          <a
                            href="https://docs.spikedata.co.za/"
                            class="xl:mt-10 mt-5 mx-auto lg:ml-0 text-center relative inline-flex items-center px-6 py-2 border border-transparent text-lg font-medium rounded-md text-gray-900 bg-orange-400 shadow-md hover:bg-orange-500 focus:outline-none transition duration-300 ease-in-out"
                          >
                            <span>See docs</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Slides -->
                  <div class="swiper-slide flex p-4">
                    <div class="flex flex-col lg:flex-wrap lg:grid lg:grid-cols-12 lg:gap-8">
                      <div class="sm:text-center lg:col-span-6 lg:text-left">
                        <h2>
                          <span
                            class="mt-1 block text-3xl tracking-tight font-normal sm:text-4xl xl:text-5xl xl:leading-snug"
                          >
                            <span class="block text-gray-900">22seven uses our software</span>
                          </span>
                        </h2>
                        <p class="mt-3 text-base text-gray-900 sm:mt-5 sm:text-xl lg:text-lg xl:text-2xl">
                          You may already have used our product - 22seven uses our API when you import a bank statement
                          into the 22seven app.
                        </p>

                        <div class="lg:mt-10 mt-5 flex justify-center lg:justify-start">
                          <div class="rounded-md shadow">
                            <a
                              :href="signInUrl"
                              class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 md:py-4 md:text-lg md:px-10 transition duration-300 ease-in-out"
                            >
                              Get started
                            </a>
                          </div>
                        </div>

                        <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                          Free trial, no credit card required.
                        </p>
                      </div>
                      <div class="relative lg:col-span-6 flex justify-center lg:justify-end flex-1 mt-10">
                        <div class="bg-gray-200 w-full max-w-xl flex items-center justify-center xl:min-h-[20rem]">
                          <img
                            src="/img/hero/22seven-spike-integration.png"
                            alt="22seven spike integration"
                            class="object-cover max-w-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- If we need pagination -->
              <div class="swiper-pagination inset-x-0 bottom-5 flex justify-center space-x-3 pt-10"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- Overview -->
      <section id="overview" class="bg-gray-100 relative py-10 lg:py-20">
        <div class="bg-dots-pattern absolute inset-x-0 h-64 bottom-0"></div>
        <div class="max-w-screen-xl mx-auto px-4 md:px-8 2xl:px-0 relative z-10">
          <!-- heading -->
          <div class="lg:text-center">
            <h2 class="text-base text-primary font-semibold tracking-wide uppercase">Overview</h2>
            <p class="mt-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl">
              PDFs are not a good format for sharing bank transactions
            </p>
            <p class="mt-10 text-gray-500 lg:mx-auto text-justify text-last-left">
              The pdf format was designed with the goal of being able to create pixel perfect designs NOT as an
              effective means to share numerical data. If you want to extract your financial transactions from a debit
              or credit card statement you're going to have to spend 10 mins or more per pdf, manually extracting and
              cleaning up the data. Good luck to you if you've got a 200 page pdf or a folder full of pdfs to process -
              that's a lot of manual effort!
            </p>
            <div class="flex justify-start my-7">
              <a
                href="https://docs.spikedata.co.za/articles/why-pdf-processing-is-difficult/"
                class="inline-flex items-center px-7 py-3 shadow-sm text-sm font-medium rounded-md text-primary bg-white hover:bg-gray-50 focus:outline-none"
              >
                Learn more
              </a>
            </div>
          </div>
          <div class="lg:text-lest pb-10">
            <h3 class="text-xl text-gray-900 font-semibold">Spike extracts transactions in an instant</h3>
            <p class="mt-4 text-gray-500 lg:mx-auto text-justify text-last-left">
              Spike extracts transactions for you instantly. Drop a pdf onto our online converter and you'll be able to
              use your transactions in variety of other programs like Excel, Sage or Xero. Our technology has made bank
              statements usable in a number of different applications:
            </p>
          </div>

          <div class="grid grid-cols-1 gap-y-7 lg:grid-cols-3 lg:gap-y-0 lg:gap-x-8">
            <div class="flex flex-col bg-white rounded-lg shadow-md">
              <div class="flex-1 relative pb-16 p-6">
                <h3 class="text-3xl font-extrabold text-gray-900">Lending</h3>
                <p class="mt-4 xl:text-lg leading-relaxed text-gray-500">
                  Lenders use Spike in order to perform affordability assessments during a loan application.
                </p>
              </div>
              <div class="bg-primary rounded-bl-lg rounded-br-lg relative">
                <div
                  class="absolute top-0 p-3 flex justify-center items-center h-16 w-16 xl:w-24 xl:h-24 bg-gray-200 rounded-full left-4 transform -translate-y-1/2"
                >
                  <img src="/img/icon-lending.svg" alt="lending" class="object-cover max-w-full" />
                </div>
                <a
                  href="#clients"
                  class="xl:text-lg font-medium text-white hover:text-gray-200 pl-20 xl:pl-28 py-5 flex min-h-[5.5rem] xl:min-h-0 justify-start items-center"
                >
                  Sasfin, Merchant Capital, and others
                </a>
              </div>
            </div>
            <div class="flex flex-col bg-white rounded-lg shadow-md">
              <div class="flex-1 relative pb-16 p-6">
                <h3 class="text-3xl font-extrabold text-gray-900">Bookkeeping</h3>
                <p class="mt-4 xl:text-lg leading-relaxed text-gray-500">
                  Accountants use Spike in order to import transactions from statements into accounting packages, in
                  order to perform monthly book keeping.
                </p>
              </div>
              <div class="bg-primary rounded-bl-lg rounded-br-lg relative">
                <div
                  class="absolute top-0 p-3 flex justify-center items-center h-16 w-16 xl:w-24 xl:h-24 bg-gray-200 rounded-full left-4 transform -translate-y-1/2"
                >
                  <img src="/img/icon-bookkeeping.svg" alt="lending" class="object-cover max-w-full" />
                </div>
                <a
                  href="#features"
                  class="xl:text-lg font-medium text-white hover:text-gray-200 pl-20 xl:pl-28 py-5 flex min-h-[5.5rem] xl:min-h-0 justify-start items-center"
                >
                  We support OFX and Xero
                </a>
              </div>
            </div>
            <div class="flex flex-col bg-white rounded-lg shadow-md">
              <div class="flex-1 relative pb-16 p-6">
                <h3 class="text-3xl font-extrabold text-gray-900">Personal use</h3>
                <p class="mt-4 xl:text-lg leading-relaxed text-gray-500">
                  There are many personal uses for transactions - for example drawing up a <b>budget</b>, or submitting
                  your <b>taxes</b>. Use Spike to convert your pdf bank statements into formats which you can work with.
                </p>
              </div>
              <div class="bg-primary rounded-bl-lg rounded-br-lg relative">
                <div
                  class="absolute top-0 p-3 flex justify-center items-center h-16 w-16 xl:w-24 xl:h-24 bg-gray-200 rounded-full left-4 transform -translate-y-1/2"
                >
                  <img src="/img/icon-personal-use.svg" alt="lending" class="object-cover max-w-full" />
                </div>
                <a
                  href="https://22seven.com/"
                  class="xl:text-lg font-medium text-white hover:text-gray-200 pl-20 xl:pl-28 py-5 flex min-h-[5.5rem] xl:min-h-0 justify-start items-center"
                >
                  Used by 22seven.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Features -->
      <section id="features" class="py-10 lg:py-20">
        <div class="max-w-screen-xl mx-auto px-4 md:px-8 2xl:px-0">
          <div class="lg:text-center">
            <h2 class="text-base text-primary font-semibold tracking-wide uppercase">Features</h2>
            <p class="mt-8 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl">
              There's an easier way to access bank transactions
            </p>
            <p class="mt-10 text-xl text-gray-500 lg:mx-auto max-w-4xl">
              Do you need to process bank transactions? Does your existing pipeline tick all of these boxes? Why not try
              out our solution - you can do so
              <a href="#faq-free" class="text-primary hover:text-primary-600 font-bold underline">for free</a>
              .
            </p>
          </div>

          <div class="mt-10">
            <dl class="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10">
              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/library"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
                      ></path>
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Extract</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  <p>
                    Parse transactions and account holder info from a pdf. All 1st and 2nd tier South African banks are
                    supported, including both debit and credit card formats.
                  </p>
                  <img src="/img/bank-icons.png" alt="Bank Icons" class="mt-5" />
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/at-symbol"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Simple pricing</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  We charge a simple flat fee per pdf. We don't charge per page. That way there are no unexpected
                  surprises when for example processing a 200 page document - you will be charged the same amount as a
                  single page document.
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/at-symbol"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Accept statements by email</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  Banks send out statements every month by email. Spike allows you to access bank transactions by simply
                  forwarding this email to a monitored inbox. This is useful for loan applications where a client is
                  filling out your application form on a smart phone
                  <a href="javascript:void(0)" class="text-primary hover:text-primary-600 font-bold">1</a>. Even more
                  powerfully it can be used for automatic import of client transactions on a monthly basis
                  <a href="javascript:void(0)" class="text-primary hover:text-primary-600 font-bold">2</a>.
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/lightning-bolt"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">
                    Detect fraudulently modified statements
                  </p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  People often think that PDFs are a read-only format. However this is simply not true: there are many
                  freely available online pdf editors which make it super simple to change an income of R10,000 to
                  R100,000 in ways which are impossible to detect visually. Spike has developed sophisticated
                  <b>authenticity</b> checks which determine whether a pdf is an original bank statement or not.
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/lightning-bolt"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 10V3L4 14h7v7l9-11h-7z"
                      ></path>
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Use our API</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  Using our API you can build statement processing directly into your app. This let's you have full
                  control over the design of your loan application funel, or optimise your back-office processes.
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/lightning-bolt"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Convert</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  Write bank transactions to another format so that you can access them in an external program. We
                  currently support these formats: Json, Excel, Xero, OFX
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/lightning-bolt"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Desktop converter</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  If you have a folder of pdfs to convert, then try our desktop converter. This value add software is
                  provided free of charge (you only pay for pdf conversion).
                </dd>
              </div>

              <div class="relative">
                <dt>
                  <div class="absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                    <svg
                      class="h-6 w-6"
                      x-description="Heroicon name: outline/lightning-bolt"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </div>
                  <p class="ml-16 text-lg leading-6 font-medium text-gray-900">Support</p>
                </dt>
                <dd class="mt-2 ml-16 text-base text-gray-500">
                  Need our help? Our premium plans have you covered, with our guaranteed turnaround email support.
                </dd>
              </div>
            </dl>
          </div>
        </div>

        <div class="max-w-screen-xl mx-auto px-4 xl:px-0">
          <div class="max-w-screen-xl px-16 mx-auto mt-10">
            <ol class="list-decimal text-primary font-bold space-y-3">
              <li>
                <span class="text-base text-gray-500 font-normal">
                  a “file upload” interface is cumbersome on phone: as a case in point try find a downloaded document on
                  your phone, or worse a file attachment in an email.
                </span>
              </li>
              <li>
                <span class="text-base text-gray-500 font-normal">
                  just ask your clients to setup a secondary email address on their banks' website account to which
                  their monthly statements will be emailed
                </span>
              </li>
            </ol>
          </div>
        </div>
      </section>

      <!-- Pricing -->
      <section id="pricing" class="bg-gray-100 relative py-10 lg:py-20">
        <div class="max-w-screen-xl mx-auto px-4 md:px-8 2xl:px-0 relative z-10">
          <!-- heading -->
          <div class="lg:text-center">
            <h2 class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl">Pricing</h2>
          </div>
          <div class="lg:text-lest py-10">
            <PricingGrid />
          </div>
        </div>
      </section>

      <!-- Clients -->
      <section id="clients" class="relative py-10 lg:py-20">
        <div class="max-w-screen-xl mx-auto px-4 md:px-8 2xl:px-0 relative z-10">
          <!-- heading -->
          <div class="lg:text-center">
            <h2 class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl">Trusted by</h2>
          </div>
          <div class="lg:text-lest py-10 flex lg:justify-center items-center flex-wrap gap-x-20 gap-y-10">
            <a href="https://www.sasfin.com/">
              <img src="/img/sasfinlogo.png" class="max-h-[3rem]" alt="sasfinlogo" />
            </a>
            <a href="https://22seven.com/">
              <img src="/img/logo-22seven.png" class="max-h-[3rem]" alt="logo-22seven" />
            </a>
            <a href="https://www.merchantcapital.co.za/">
              <div class="h-[3rem] pl-1 pr-3 py-1" style="background-color: #1b1f2c">
                <img src="/img/merchantcapital.png" class="max-h-full w-auto" alt="merchantcapital" />
              </div>
            </a>
            <a href="https://www.retailcapital.co.za/">
              <img src="/img/retailcapital.svg" class="h-[3rem] w-auto" alt="retailcapital" />
            </a>
            <a href="https://www.connected.co.za/">
              <img src="/img/connected.png" class="max-h-[3rem]" alt="connected" />
            </a>
            <a href="https://www.payabill.biz/">
              <img src="/img/payabill.png" class="max-h-[3rem]" alt="payabill" />
            </a>
            <a href="https://www.spartan.co.za/">
              <img src="/img/spartan.png" class="max-h-[3rem]" alt="spartan" />
            </a>
            <a href="https://www.africadirectgroup.co.za/">
              <img src="/img/africadirect.png" class="max-h-[3rem]" alt="africadirect" />
            </a>
            <a href="http://tauruscapital.co.za/"><img src="/img/Taurus.png" class="max-h-[3rem]" alt="Taurus" /></a>
          </div>
        </div>
      </section>

      <!-- Security -->
      <section id="security" class="relative py-10 lg:py-20 bg-gray-100">
        <div
          class="bg-chip-pattern bg-repeat-y bg-right absolute left-0 inset-y-0 2xl:w-60 w-40 opacity-40 xl:opacity-100"
        ></div>
        <div class="max-w-screen-lg mx-auto px-4 md:px-8 2xl:px-0 relative z-10">
          <div class="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 mb-5 md:mb-0 lg:max-w-none">
            <h2 class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl">Security</h2>
          </div>
          <div class="md:grid md:grid-cols-6 md:gap-8">
            <div class="relative md:row-start-2 md:col-start-5 md:col-span-2">
              <div class="relative text-base mx-auto max-w-prose lg:max-w-none">
                <figure>
                  <div
                    class="aspect-w-12 aspect-h-7 w-60 mx-auto md:w-auto lg:aspect-none flex md:justify-end justify-center"
                  >
                    <img class="object-cover object-center" src="/img/lock.svg" alt="lockt" />
                  </div>
                </figure>
              </div>
            </div>
            <div
              class="prose text-gray-500 mx-auto md:max-w-none md:row-start-2 md:col-start-1 md:col-span-4 lg:pr-10 xl:pr-20 2xl:pr-40"
            >
              <p>When you're dealing with people's finances security is of the upmost concern.</p>
              <p>
                Our infrastructure conforms to industry best practices
                <a href="javascript:void(0)" class="text-primary hover:text-primary-600 font-bold">1</a>
                : secure https communications with JWT auth, encrypt at rest data, all servers are secured within an AWS
                VPC.
              </p>
              <p>
                We have been independently audited by two third party penetration testing companies
                <a href="javascript:void(0)" class="text-primary hover:text-primary-600 font-bold">2</a>
                and have been awarded a qualified exemption in each case. Reports are available upon request.
              </p>
              <p>
                Our AWS cloud architecture has passed muster with an internal review from Old Mutual security staff.
              </p>
              <div class="flex justify-start my-7">
                <a
                  href="https://docs.spikedata.co.za/product/security/"
                  class="inline-flex no-underline items-center px-7 py-4 shadow-sm text-sm font-medium rounded-md text-primary bg-white hover:bg-gray-50 focus:outline-none"
                >
                  Learn more
                </a>
              </div>

              <ol class="text-primary font-bold space-y-3">
                <li>
                  <span class="text-base text-gray-500 font-normal">
                    We adhere to
                    <a href="https://owasp.org/" title="Open Web Application Security Project">OWASP</a>
                    security best practices
                  </span>
                </li>
                <li>
                  <span class="text-base text-gray-500 font-normal">Mobius Consulting, and Exocet Security</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <!-- Privacy -->
      <section id="privacy" class="bg-white relative py-10 lg:py-20">
        <div class="bg-plus-pattern absolute inset-y-0 right-0 2xl:w-60 w-28 opacity-40 xl:opacity-100"></div>
        <div class="max-w-screen-lg mx-auto px-4 md:px-8 xl:px-0 relative z-10">
          <div class="mx-auto text-base max-w-prose lg:grid lg:grid-cols-2 mb-5 md:mb-0 lg:max-w-none">
            <h2
              class="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 lg:text-4xl lg:row-start-2 lg:col-start-2"
            >
              Privacy
            </h2>
          </div>
          <div class="md:grid md:grid-cols-6 md:gap-8">
            <div class="relative md:row-start-2 md:col-start-1 md:col-span-2 xl:col-span-3">
              <div class="relative text-base mx-auto max-w-prose lg:max-w-none">
                <figure>
                  <div class="aspect-w-12 aspect-h-7 w-60 mx-auto md:w-auto lg:aspect-none flex justify-start">
                    <img class="object-cover object-center" src="/img/lock-yellow.png" alt="lockt" />
                  </div>
                </figure>
              </div>
            </div>

            <div
              class="prose text-gray-500 mx-auto md:max-w-none md:row-start-2 md:col-start-3 md:col-span-4 xl:col-span-3"
            >
              <p>
                All pdfs are deleted automatically on all plans. We may retain some intermediate data in order to
                improve the quality of our product. These are the specific scenarios in which we retain data:
              </p>
              <ol class="text-primary font-bold space-y-3">
                <li>
                  <span class="text-base text-gray-500 font-normal">
                    When a new statement format is detected, we retain 1
                    <b>redacted</b>
                    image for use in our
                    <a href="https://docs.spikedata.co.za/statements/">statement library</a>
                    (in order to showcase all supported statement types)
                  </span>
                </li>
                <li>
                  <span class="text-base text-gray-500 font-normal">
                    On error, a pdf is retained for up to 1 week in order to allow us time to review and fix the error
                  </span>
                </li>
                <li>
                  <span class="text-base text-gray-500 font-normal">
                    Text of the first page may be retained for ongoing identification analysis – i.e. for back-testing
                    of the rules which distinguish one supported statement type from another
                  </span>
                </li>
              </ol>
              <div class="flex justify-start my-7">
                <a
                  href="https://docs.spikedata.co.za/legal/privacy/"
                  class="inline-flex no-underline items-center px-7 py-4 shadow-sm text-sm font-medium rounded-md text-primary bg-gray-200 hover:bg-gray-300 focus:outline-none duration-300 transition ease-in-out border border-white"
                >
                  Learn more
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- FAQ -->
      <section id="faq" class="py-10 lg:py-20">
        <Faq />
      </section>

      <!-- CTA -->
      <section class="bg-white py-10 lg:py-20">
        <div class="max-w-screen-lg mx-auto px-4 md:px-8 xl:px-0 text-center">
          <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 lg:text-4xl">
            <span class="block">Start your free trial today</span>
          </h2>
          <div class="mt-7 sm:flex sm:justify-center">
            <div class="rounded-md shadow">
              <a
                :href="signInUrl"
                class="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-600 md:py-4 md:text-lg md:px-10 transition duration-300 ease-in-out"
              >
                Get started
              </a>
            </div>
          </div>
          <p class="mt-3 text-base text-gray-500 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
            Free trial, no credit card required.
          </p>
        </div>
      </section>
    </main>

    <!-- Footer -->
    <footer class="bg-primary" aria-labelledby="footerHeading">
      <h2 id="footerHeading" class="sr-only">Footer</h2>
      <div class="max-w-screen-xl mx-auto pt-12 px-4 sm:px-8 2xl:px-0 lg:pt-16 pb-7">
        <div class="md:grid md:grid-cols-3 md:gap-8">
          <div class="space-y-8 md:col-span-1">
            <img class="h-16" src="/img/spike-logo-white.svg" alt="spike" />
            <p class="text-white text-base">Liberating bank transactions</p>
            <div class="flex space-x-6">
              <a href="https://github.com/spikedata/" class="text-white hover:text-gray-200">
                <span class="sr-only">GitHub</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill-rule="evenodd"
                    d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                    clip-rule="evenodd"
                  />
                </svg>
              </a>

              <a href="https://medium.com/spikedata" class="text-white hover:text-gray-200">
                <span class="sr-only">Blog</span>
                <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    fill-rule="evenodd"
                    d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.416 25.416 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.687 8.687 0 0112 3.475zm-3.633.803a53.896 53.896 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.318 35.318 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.468 8.468 0 01-3.655 5.715z"
                    clip-rule="evenodd"
                  />
                </svg>
              </a>
            </div>
          </div>
          <div class="mt-12 grid grid-cols-3 gap-8 md:mt-0 md:col-span-2">
            <div class="sm:grid sm:grid-cols-2 sm:gap-8 col-span-2">
              <div>
                <h3 class="text-lg font-semibold text-white tracking-wider uppercase">Support</h3>
                <ul class="mt-4 space-y-4">
                  <li>
                    <a
                      href="https://docs.spikedata.co.za/product/support/"
                      class="text-base text-white hover:text-gray-200"
                    >
                      Get support
                    </a>
                  </li>

                  <li>
                    <a href="https://docs.spikedata.co.za/" class="text-base text-white hover:text-gray-200">
                      Documentation
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.postman.com/spikedata/workspace/spike-statements-api/documentation/14339623-f25b59e6-573d-4b20-9c71-0084a04a02c1"
                      class="text-base text-white hover:text-gray-200"
                    >
                      API reference
                    </a>
                  </li>
                </ul>
              </div>
              <div class="mt-12 sm:mt-0">
                <h3 class="text-lg font-semibold text-white tracking-wider uppercase">Company</h3>
                <ul class="mt-4 space-y-4">
                  <li>
                    <a href="https://docs.spikedata.co.za/about/" class="text-base text-white hover:text-gray-200">
                      About
                    </a>
                  </li>

                  <li>
                    <a href="mailto:support@spikedata.co.za" class="text-base text-white hover:text-gray-200">
                      Contact us
                    </a>
                  </li>

                  <li>
                    <a href="https://medium.com/spikedata" class="text-base text-white hover:text-gray-200">Blog</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sm:grid sm:gap-8">
              <div>
                <h3 class="text-lg font-semibold text-white tracking-wider uppercase">Legal</h3>
                <ul class="mt-4 space-y-4">
                  <li>
                    <a
                      href="https://docs.spikedata.co.za/legal/popia/"
                      class="text-base text-white hover:text-gray-200"
                    >
                      POPIA
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://docs.spikedata.co.za/legal/privacy/"
                      class="text-base text-white hover:text-gray-200"
                    >
                      Privacy
                    </a>
                  </li>

                  <li>
                    <a href="https://docs.spikedata.co.za/legal/" class="text-base text-white hover:text-gray-200">
                      T &amp; C's
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-12 border-t border-white border-opacity-20 pt-8">
          <p class="text-sm text-white text-opacity-70 xl:text-center font-light">
            &copy; 2021 Mighty Machines (pty) ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { ref } from "vue";
import Faq from "./components/Faq.vue";
import PricingGrid from "./components/PricingGrid.vue";
import { AppName, ScreenRoute } from "@spike/app2-sitemap/src/auth.js";

export default {
  components: {
    Faq,
    PricingGrid,
  },
  setup() {
    const menu = ref(false);
    const signInUrl = ref(`/${AppName}/#${ScreenRoute.SignIn}`);
    return { menu, signInUrl };
  },
};
</script>
